import React from 'react';
import PropTypes from 'prop-types';

const CustomMeter = ({ meterProps, displayedLabel }) => {
  const {
    value,
    max
  } = meterProps;

  const meterFullness = `${(value + 1) / (max + 1) * 100}%`;

  return (
    <div className='meter-wrap'>
      <meter {...meterProps} style={{ width: meterFullness }}>
        {(displayedLabel) ? <span>{displayedLabel}</span> : null}
      </meter>
    </div>
  );
};

CustomMeter.propTypes = {
  meterProps: PropTypes.shape({
    value: PropTypes.number.isRequired,
    min: PropTypes.number.isRequired,
    low: PropTypes.number,
    optimum: PropTypes.number,
    high: PropTypes.number,
    max: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired
  }).isRequired,
  displayedLabel: PropTypes.string
};

export default CustomMeter;